"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beforeUnload = exports.urlToAction = exports.actionToUrl = void 0;

var router_1 = require("./router");

var url_pattern_1 = __importDefault(require("url-pattern"));

var utils_1 = require("./utils");

var kea_1 = require("kea");

function assureConnectionToRouter(logic) {
  if (!logic.connections[router_1.router.pathString]) {
    (0, kea_1.connect)({
      logic: [router_1.router]
    })(logic);
  }
}

function actionToUrl(input) {
  return function (logic) {
    var inputEntries = typeof input === 'function' ? input(logic) : input;
    assureConnectionToRouter(logic);
    var newListeners = {};

    var _loop_1 = function _loop_1(actionKey, urlMapping) {
      newListeners[actionKey] = function (payload) {
        var _a = router_1.router.values.location,
            pathname = _a.pathname,
            search = _a.search,
            hash = _a.hash;
        var currentPathInWindow = pathname + search + hash;
        var pathInRoutes = urlMapping(payload);

        if (typeof pathInRoutes === 'undefined') {
          return;
        }

        var pathFromRoutesToWindow = (0, router_1.getRouterContext)().pathFromRoutesToWindow;
        var pathInWindow = Array.isArray(pathInRoutes) ? pathFromRoutesToWindow(pathInRoutes[0]) + (0, utils_1.stringOrObjectToString)(pathInRoutes[1], '?') + (0, utils_1.stringOrObjectToString)(pathInRoutes[2], '#') : pathFromRoutesToWindow(pathInRoutes);

        if (currentPathInWindow !== pathInWindow) {
          if (Array.isArray(pathInRoutes) && pathInRoutes[3] && pathInRoutes[3].replace) {
            router_1.router.actions.replace(pathInWindow);
          } else {
            router_1.router.actions.push(pathInWindow);
          }
        }
      };
    };

    for (var _i = 0, _a = Object.entries(inputEntries); _i < _a.length; _i++) {
      var _b = _a[_i],
          actionKey = _b[0],
          urlMapping = _b[1];

      _loop_1(actionKey, urlMapping);
    }

    (0, kea_1.listeners)(newListeners)(logic);
  };
}

exports.actionToUrl = actionToUrl;

function urlToAction(input) {
  return function (logic) {
    var inputEntries = typeof input === 'function' ? input(logic) : input;
    assureConnectionToRouter(logic);
    logic.cache.__routerListeningToLocation = true;
    var newListeners = {};

    var _a = (0, router_1.getRouterContext)(),
        urlPatternOptions = _a.options.urlPatternOptions,
        pathFromWindowToRoutes = _a.pathFromWindowToRoutes;

    var routes = Object.entries(inputEntries).map(function (_a) {
      var pathFromRoutes = _a[0],
          action = _a[1];
      return {
        path: pathFromRoutes,
        pattern: new url_pattern_1.default(pathFromRoutes, urlPatternOptions),
        action: action
      };
    });

    newListeners[router_1.router.actionTypes.locationChanged] = function (payload, _, __, previousState) {
      var pathname = payload.pathname,
          searchParams = payload.searchParams,
          hashParams = payload.hashParams;
      var pathInWindow = decodeURI(pathname);
      var pathInRoutes = pathFromWindowToRoutes(pathInWindow);
      var matchedRoute;
      var params;

      for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var route = routes_1[_i];
        params = route.pattern.match(pathInRoutes);

        if (params) {
          matchedRoute = route;
          break;
        }
      }

      if (matchedRoute) {
        var previousLocation = router_1.router.selectors.currentLocation(previousState);
        matchedRoute.action(params, searchParams, hashParams, payload, previousLocation);
      }
    };

    (0, kea_1.listeners)(newListeners)(logic);
    (0, kea_1.afterMount)(function (logic) {
      var _a;

      var previousState = (0, kea_1.getContext)().store.getState();

      for (var _i = 0, _b = (_a = logic.listeners[router_1.router.actionTypes.locationChanged]) !== null && _a !== void 0 ? _a : []; _i < _b.length; _i++) {
        var listener = _b[_i];
        listener({
          type: router_1.router.actionTypes.locationChanged,
          payload: __assign(__assign({}, router_1.router.values.location), {
            searchParams: router_1.router.values.searchParams,
            hashParams: router_1.router.values.hashParams,
            method: 'POP',
            initial: true
          })
        }, previousState);
      }
    })(logic);
  };
}

exports.urlToAction = urlToAction;

function beforeUnload(input) {
  return function (logic) {
    var config = typeof input === 'function' ? input(logic) : input;

    var beforeWindowUnloadHandler = function beforeWindowUnloadHandler(e) {
      if (config.enabled()) {
        e.preventDefault();
        e.returnValue = config.message;
      }
    };

    (0, kea_1.afterMount)(function () {
      var beforeUnloadInterceptors = (0, router_1.getRouterContext)().beforeUnloadInterceptors;
      beforeUnloadInterceptors.add(config);
      window.addEventListener('beforeunload', beforeWindowUnloadHandler);
    })(logic);
    (0, kea_1.beforeUnmount)(function () {
      var beforeUnloadInterceptors = (0, router_1.getRouterContext)().beforeUnloadInterceptors;
      beforeUnloadInterceptors.delete(config);
      window.removeEventListener('beforeunload', beforeWindowUnloadHandler);
    })(logic);
  };
}

exports.beforeUnload = beforeUnload;